import { render, staticRenderFns } from "./PurchaseFix.vue?vue&type=template&id=4656c2a1&"
import script from "./PurchaseFix.vue?vue&type=script&lang=js&"
export * from "./PurchaseFix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports